import { authMiddleware } from "@/middleware";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardLayout } from "@/components";
import ProxyPage from "@/pages/proxies/Proxies";

export const Route = createFileRoute("/_market/proxy/")({
	component: () => (
		<DashboardLayout>
			<ProxyPage />
		</DashboardLayout>
	),
	loader: authMiddleware,
});
